<script>
export default {
  props: [],
};
</script>

<template>
  <div class="f-info">
    <slot></slot>
  </div>
</template>

<style scoped>
.f-info {
  display: flex;
  gap: 7px;
  padding: 8px;
  border-left: 4px solid;
  border-radius: 4px;
  border-color: var(--blue);
  color: var(--blue);
  background-color: var(--blue-a5);
  font-weight: 500;
  font-size: 12px;
}

.f-info.warning {
  border-color: var(--statusNotice);
  color: var(--statusNotice);
  background-color: var(--statusNotice-a5);
}

.f-info.error {
  border-color: var(--statusNegative);
  color: var(--statusNegative);
  background-color: var(--statusNegative-a5);
}
</style>